import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StoreConfig } from '../../api/storeApi';

interface StoreConfigState {
  config: StoreConfig | null;
  loading: boolean;
  error: string | null;
}

const initialState: StoreConfigState = {
  config: null,
  loading: false,
  error: null,
};

const storeConfigSlice = createSlice({
  name: 'storeConfig',
  initialState,
  reducers: {
    setStoreConfig: (state, action: PayloadAction<StoreConfig>) => {
      state.config = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { setStoreConfig, setLoading, setError } = storeConfigSlice.actions;
export const storeConfigReducer = storeConfigSlice.reducer;
